(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection_grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    Alpine.data('collectionFilter', ( formEl ) => ({
      form: formEl,
      layout: 'grid',
      init(){
        var layout_cookie = this.getCookie('seyberts_layout');
        if(layout_cookie){
          this.layout = layout_cookie;
        }
      },
      changeLayout(layout = false){
        if(typeof layout === 'string' || layout instanceof String){
          this.layout = layout;
          this.setCookie('seyberts_layout', layout, 365);
        }
      },
      setCookie(cname = false, cvalue = false, exdays = 1) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        let expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
      },
      getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return false;
      },
      formSubmit(){
        this.form.submit();
      }
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    Alpine.data('slideshow', (autoPlay = true, slideTiming = 3000, numOfSlides = 1) => ({
      autoPlay: autoPlay,
      slideTiming:slideTiming,
      numOfSlides:numOfSlides,
      activeSlide: 1,
      timer:null,
      init(){
        if (this.autoPlay){
          this.startTheSlideshow();
        }
      },
      slideInteraction:{
        ['@mouseover'](){
          this.stopTheSlideshow();
        },
        ['@mouseout'](){
          this.startTheSlideshow();
        },
      },
      startTheSlideshow(){
        this.timer = setInterval(()=> { this.nextSlide() }, this.slideTiming);
      },
      stopTheSlideshow(){
        clearInterval(this.timer);
      },
      nextSlide(){
        if(this.activeSlide == this.numOfSlides){
          this.activeSlide = 1;
        } else {
           this.activeSlide++;
        }
      },
      prevSlide(){
        if(this.activeSlide == 1){
          this.activeSlide = this.numOfSlides;
        } else {
           this.activeSlide--;
        }
      },
      goToSlide(id){
        this.activeSlide = id;
      }
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product_info"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('alpine:init', () => {
  Alpine.data('variantSelect', (productData = [], optionData = [], defaultSelectedData = false, variantAvailabilityData = []) => ({
  	product: productData,
  	options: optionData,
  	defaultSelected: defaultSelectedData,
  	variantAvailability: variantAvailabilityData,
  	selectedVariant: false,
  	selectedMedia: 0,
  	selectedQty: 1,
  	selectedOptions: {},
  	selectedPrice: false,
    customizations: {},
    allAvailable: true,
    isWaiting: false,
    waitlistMessage: false,
    // showToWaiting: false,
    showToWaiting: true,
    loading: false,
    maxQty: 10000,
    init(){
      // console.clear();
      //console.log(this.product);
      var self = this;
      var formEl = this.$el.querySelector('form');
      if (formEl) {
        formEl.removeAttribute('method'); // force JS (addToCart) to handle submission instead of a native post to /cart/add
      }
      self.product.variants.forEach(function (variant, index) { // incorporate inventory levels into product variants
        if (variant.id in self.variantAvailability){
          self.product.variants[index]['inventory_quantity'] = self.variantAvailability[variant.id][0];   
          self.product.variants[index]['inventory_policy'] = self.variantAvailability[variant.id][1];        
        }
      });
      this.hashCheck();
      this.customizations.has_addons = false;
      this.customizations['defaults'] = {};
      this.customizations['included_addon_qty'] = {};
      // Bundle hash
      this.customizations['bundle_id'] = Date.now();
      this.options.forEach((opt) =>{
        var defaultOption = this.defaultSelected['options'] ? this.defaultSelected['options'][opt.position - 1] : false;
        this.selectedOptions['option'+opt.position] = defaultOption;
      });
      this.findMatchingVariant();
      this.$watch('selectedOptions',(value) => this.findMatchingVariant());
      this.$watch('selectedQty',(value) => this.setProductPrice());
    },
    availabilityCheck(){
      this.allAvailable = true;
      if( !this.selectedVariant || !this.selectedVariant.available ){
        this.allAvailable = false;
      } else {
        this.maxQty = 10000;
        if( this.selectedVariant.inventory_policy == 'deny' && this.selectedVariant.inventory_quantity > 0 ){ // cap qty select to total qty on hand for selected variant
          this.maxQty = this.selectedVariant.inventory_quantity;
        }
        for (const addonId in this.customizations) {
          if( ( typeof this.customizations[addonId] === 'object' && 'available' in this.customizations[addonId] ) && ( ( this.customizations['defaults'][addonId]['in_inventory'] && this.customizations[addonId]['id'] == this.customizations['defaults'][addonId]['id'] ) || ( this.customizations[addonId]['id'] != this.customizations['defaults'][addonId]['id'] ) ) ){
            if ( this.customizations[addonId]['available'] ){
              if( this.customizations[addonId]['inventory_policy'] == 'deny' && this.customizations[addonId]['inventory_quantity'] < this.maxQty ){ // lower max qty if selected addon has less on hand than current maxqty
                this.maxQty = this.customizations[addonId]['inventory_quantity'];
              }
            } else {
              this.allAvailable = false;
            }
          } else if( addonId == 'included_addon_qty' ){
            for (const includedAddonId in this.customizations[addonId]) {
              if( this.customizations[addonId][includedAddonId] > 0 && this.customizations[addonId][includedAddonId] < this.maxQty ){
                this.maxQty = this.customizations[addonId][includedAddonId];
              } else if( this.customizations[addonId][includedAddonId] < 1 ) {
                this.allAvailable = false;
              }
            }
          }
        }
      }
      this.adjustQty(0);
    },
    findMatchingVariant(){
      //console.log(this.customizations);
      var found = this.product.variants.find((variant) => {
        return this.options.every((opt) => {
          return this.selectedOptions['option'+ opt.position] == variant['option'+ opt.position];
        });
      });
      if (found){
        //console.log(found);
        this.selectedVariant = found;
        window.history.replaceState({}, found.name, window.location.origin + window.location.pathname + "?variant=" + found.id);
        this.availabilityCheck();
        this.setProductPrice();
        if(found.featured_image){
          this.setProductImage(found.featured_image.position - 1);
        }
      }
    },
    setDefaultAddons( addonId = false, collection = false, product = false, allowNone = false, defaultInInventory = true, currentDefault = false, none_text = 'None' ){
      this.customizations.has_addons = true;
      if( !currentDefault ){
        this.customizations[addonId] = {title: none_text, id: 0, product_id: 0, price: 0, addonPrice: 0, msg: '' };
      }
      var found = false;
      var defaultSKUs = [];
      if (Symbol.iterator in Object(product.tags)) {
        for (var tag of product.tags) {
          var tagSplit = tag.split('_');
          if( tagSplit.length > 1 && tagSplit[0] == 'default'){
            defaultSKUs.push( tagSplit[tagSplit.length - 1] );
          }
        }
      }
      var productData = false;
      for ( var product of collection ) {
        for ( var variant of product.variants) {
          if( ( !allowNone && !found && !currentDefault ) || defaultSKUs.includes( variant.sku ) ){
            found = variant;
            found['product_id'] = product.id;
            productData = product;
          }
        }
      }
      if (found){
        var addonPrice = defaultInInventory ? found.price : 0;
        this.customizations['defaults'][addonId] = {'id': found.id, 'product_id': found.product_id, 'price': addonPrice, 'in_inventory': defaultInInventory };
        var setProduct = found;

        if( defaultInInventory && !found.available ){ // if the default is not available
          if( productData.available ){ // ...but another variant for that product is
            for ( var variant of productData.variants) {
              if( variant.available ){
                setProduct = variant;
                setProduct['product_id'] = productData.id;
                break;
              }
            }
          } else { //... but entire product is OOS
            for ( var product of collection ) { // find the first available product and select it's first available variant
              if( product.available ){
                for ( var variant of product.variants) {
                  if( variant.available ){
                    setProduct = variant;
                    productData = product;
                    setProduct['product_id'] = productData.id;
                    break;
                  }
                }
              }
            }
          }
        }
        this.customizations[addonId]['options'] = JSON.parse( JSON.stringify( setProduct.options ) );
        this.setAddon(addonId, setProduct, productData, none_text);
      } else if(currentDefault){
        // Do nothing
      } else {
        this.customizations['defaults'][addonId] = { price: 0 }
      }
    },
    changeAddon( addonId = false, productData = false, addonKey = false, selectedOption = false, none_text = 'None' ){
      if( selectedOption ){
        this.customizations[addonId]['options'][addonKey] = selectedOption;
      } else {
        this.customizations[addonId]['options'] = [];
        this.customizations[addonId]['product_id'] = false;
      }
      var found = false;
      if( addonId && productData ){
        for ( var variant of productData.variants ) {
          if( 
            ( JSON.stringify( variant.options ) === JSON.stringify( this.customizations[addonId]['options'] ) ) || // if variant matches current selected options
            ( !selectedOption && !found && ( variant.available || !productData.available ) ) || // if selecting first available option by default
            ( !selectedOption && this.customizations['defaults'][addonId]['id'] == variant.id ) // if selecting default addon by default
          ){
            found = variant;
            found['product_id'] = productData.id;
            if( !selectedOption ){
              this.customizations[addonId]['options'] = JSON.parse( JSON.stringify( found.options ) );
            }
          }
        }
      }
      this.$dispatch('notify', { product: productData });
      this.setAddon( addonId, found, productData, none_text );
    },
    setAddon( addonId = false, found = false, product = false, none_text = 'None' ){
      var selectedAddonPrice = this.customizations['defaults'][addonId]['id'] == found.id ? this.customizations['defaults'][addonId]['price'] : found.price;
      this.customizations[addonId]['price'] = selectedAddonPrice ? selectedAddonPrice : 0;
      this.customizations[addonId]['title'] = found.name ? found.name : none_text;
      this.customizations[addonId]['sku'] = found.sku ? found.sku : '';
      this.customizations[addonId]['id'] = found.id ? found.id : 0;
      this.customizations[addonId]['product_id'] = found.product_id ? found.product_id : 0;
      this.customizations[addonId]['available'] = found.available ? found.available: true;
      this.customizations[addonId]['featured_image'] = found.featured_image ? found.featured_image : null;
      var self = this;
      if( product ){

        fetch( '/products/' + product.handle ).then( function( response ){ return response.text(); } ).then( function ( html ){
          var parser = new DOMParser(); 
          var doc = parser.parseFromString( html, 'text/html' ); 
          var availability = JSON.parse( doc.getElementById( 'product_info_wrapper' ).getAttribute( 'data-ajax' ) );
          var msg = '';
          if (found.id in availability){
            self.customizations[addonId]['inventory_policy'] = availability[found.id][1];
            self.customizations[addonId]['inventory_quantity'] = availability[found.id][0];
            if( self.customizations[addonId]['inventory_quantity'] < 1 ){ // if addon is OOS
              if( 
                ( self.customizations['defaults'][addonId]['in_inventory'] && self.customizations[addonId]['id'] == self.customizations['defaults'][addonId]['id'] )
                || ( self.customizations[addonId]['id'] != self.customizations['defaults'][addonId]['id'] )
              ){ // if default is in inventory and default is selected OR default is not selected
                if( self.customizations[addonId]['inventory_policy'] == 'deny' ){
                  var oos_msg = doc.getElementById( 'oos_msg_ajax' ).innerHTML;
                  msg = '<div class="alert alert_danger mb-2">'+ oos_msg +'</div>';
                  self.customizations[addonId]['available'] = false;
                } else if( self.customizations[addonId]['inventory_policy'] == 'continue' ){
                  var oversell_msg_ajax = doc.getElementById( 'oversell_msg_ajax' ).innerHTML;
                  msg = '<div class="alert alert_danger mb-2">'+ oversell_msg_ajax +'</div>';
                }            
              }
            }
          }
          var alert = doc.getElementById( 'alert_msg_ajax' );
          if( alert ){
            msg = alert.innerHTML;
          }

          self.customizations[addonId]['msg'] = msg;
          self.availabilityCheck();
        })


      } else {
        self.customizations[addonId]['msg'] = '';
        self.availabilityCheck();
      }
      this.setProductPrice();
      // console.log(this.customizations);
    },
    setProductPrice(){
      console.log('Customizations');
      console.log(this.customizations);
      if(this.selectedQty < 1){
        this.selectedQty = 1;
      }
      var productPrice = 0;
      var productSavings = 0;
      var customization = 0;
      var defaultsCost = 0;
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      });
      this.selectedPrice = {};
// Product Price
      productPrice = this.selectedVariant['price'];
      if(this.customizations['defaults']){
        for(defaultAddonId in this.customizations['defaults']){
          defaultsCost = defaultsCost + this.customizations['defaults'][defaultAddonId]['price'];
          customization = customization - this.customizations['defaults'][defaultAddonId]['price'];
        }
      }
      this.customizations['defaults_addon_price'] = defaultsCost;
      this.selectedPrice['price'] = formatter.format(productPrice / 100 );
// Savings
      if(this.selectedVariant['compare_at_price'] != null && this.selectedVariant['compare_at_price'] > this.selectedVariant['price']){
        productSavings = productSavings + this.selectedVariant['compare_at_price'] - this.selectedVariant['price'];
      }
      if(productSavings > 0){
        this.selectedPrice['savings'] = formatter.format(productSavings / 100);
        this.selectedPrice['compare'] = formatter.format((productPrice + productSavings) / 100);
      }
// Customizations
      // console.log(this.customizations);
      for (addonId in this.customizations) {
        if( this.customizations[addonId].price && this.customizations[addonId].price > 0 ){
          customization = Number(customization) + Number(this.customizations[addonId].price);
        }
        if(this.customizations[addonId].addonPrice && this.customizations[addonId].addonPrice > 0  ){
          customization = Number(customization) + Number(this.customizations[addonId].addonPrice);
        }
        if(this.customizations[addonId].includedPrice && this.customizations[addonId].includedPrice > 0  ){
          customization = Number(customization) + Number(this.customizations[addonId].includedPrice);
        }
      }
      this.selectedPrice['customization'] = formatter.format(customization / 100);
      this.customizations['did'] = this.customizations['defaults_addon_price'] + this.customizations['bundle_id'];
// Tally
      this.selectedPrice['tally'] = formatter.format(((Number(productPrice) + Number(customization)) / 100) * this.selectedQty);
    },
    setProductImage(i){
      if(Number.isInteger(i) && this.product.media[i]){
        this.selectedMedia = i;
      }
    },
    adjustQty(i){
      if( this.maxQty > 0 && parseInt(this.selectedQty) + i > this.maxQty ){ // don't allow the qty to exceed the qty on hand
        this.selectedQty = this.maxQty;
      } else if( this.selectedQty < 1 ){
        this.selectedQty = 1;
      } else if( i < 0 && this.selectedQty < 2 ){
        this.selectedQty = 1;
      } else {
        this.selectedQty = parseInt(this.selectedQty) + i;
      }
    },
    waitingListCheck(email = false){


      // if(email){
      //   var self = this;
      //   var apiURL = 'https://jeffnsandbox.cavera.ca/api.php?app=product_waiting_list&shop=seyberts-billiards-supply.myshopify.com&action=check_user';
      //   apiURL += '&variant_id='+ this.selectedVariant.id
      //   apiURL += '&user_email='+ email
      //   fetch(apiURL)
      //   .then(response => response.json())
      //   .then(data => {
      //     if(data.error){
      //       self.waitlistMessage = data.error;
      //     } else if(data.success){
      //       //console.log(data);
      //       self.isWaiting = true;
      //     }
      //   })
      //   .catch(console.error);
      // } else {
      //   console.log('Invalid Email');
      // }


    },
    waitingListSubmit(email = false, id = 0){


      // if(email){
      //   var self = this;
      //   var apiURL = 'https://jeffnsandbox.cavera.ca/api.php?app=product_waiting_list&shop=seyberts-billiards-supply.myshopify.com&action=add_user&action_time=1000';
      //   apiURL += '&product_url='+ this.product.handle;
      //   apiURL += '&product_id='+ this.product.id;
      //   apiURL += '&product_title='+ encodeURI(this.product.title);
      //   apiURL += '&variant_id='+ this.selectedVariant.id;
      //   apiURL += '&variant_title='+ encodeURI(this.selectedVariant.title);
      //   apiURL += '&user_email='+ email;
      //   apiURL += '&user_id='+ id;
      //   //console.log(apiURL);
      //   fetch(apiURL)
      //   .then(response => response.json())
      //   .then(data => {
      //     self.waitlistMessage = false;
      //     //console.log(data);
      //     if(data.error){
      //       self.waitlistMessage = data.error;
      //     } else if(data.success){
      //       self.isWaiting = true;
      //     }
      //   })
      //   .catch(console.error);
      // } else {
      //   console.log('Invalid Email');
      // }


    },
    hashCheck(){   
      
      
      // var queryString = window.location.search;
      // var urlParams = new URLSearchParams(queryString);
      // var id = urlParams.get('id');
      // var variant_id = urlParams.get('variant');
      // var hash = urlParams.get('waiting');
      // var self = this;
      // var apiURL = 'https://jeffnsandbox.cavera.ca/api.php?app=product_waiting_list&shop=seyberts-billiards-supply.myshopify.com&action=check_variant';
      // apiURL += '&variant_id='+ variant_id;
      // fetch(apiURL)
      // .then(response => response.json())
      // .then(data => {
      //   self.showToWaiting = true;
      //   if(data.waiting){
      //     //console.log('has active waiting list');
      //     self.showToWaiting = false;
      //     self.hashAsync('SHA-256', id +''+ variant_id).then(outputHash => {
      //       if(outputHash == hash){
      //         self.showToWaiting = true;
      //         //console.log('has active waiting list but can be shown to this user');
      //       }
      //     });
      //   }
      // })
      // .catch(console.error);


    },
    hashAsync(algo, str) {
      return crypto.subtle.digest(algo, new TextEncoder("utf-8").encode(str)).then(buf => {
        return Array.prototype.map.call(new Uint8Array(buf), x=>(('00'+x.toString(16)).slice(-2))).join('');
      });
    },
  }));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product_recommendations"] && !Shopify.designMode) return;
  try {
    
  var loadProductRecommendationsIntoSection = function() {
    var productRecommendationsSection = document.querySelector(".product_recommendations");
    if (productRecommendationsSection === null) { return; }
    var productId = productRecommendationsSection.dataset.productId;
    var limit = productRecommendationsSection.dataset.limit;
    var requestUrl = "/recommendations/products?section_id=product_recommendations&limit="+limit+"&product_id="+productId;
    var request = new XMLHttpRequest();
    request.open("GET", requestUrl);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;
        productRecommendationsSection.innerHTML = container.querySelector(".product_recommendations").innerHTML;
      }
    };
    request.send();
  };
  document.addEventListener("shopify:section:load", function(event) {
    if (event.detail.sectionId === "product_recommendations") {
      loadProductRecommendationsIntoSection();
    }
  });
  loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
